module.exports = __webpack_public_path__ + "img/bg-news.fc8e0044.jpg";